import  { useState } from "react";
import {  useNavigate } from "react-router-dom";
import TimeAgo from "react-timeago";
import { ClipLoader } from "react-spinners";
import luxLogo from "../../assets/Logo/Horizontal0 1.png";
import { Modal, Box } from "@mui/material"; // Import Modal and Box

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90vw",
  maxWidth: 480,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const OfferCards = ({
  offer,
  onUpdate,
  onCounter,
  loading,
  error,
  updateOfferResponse,
  triggerRefresh,
  setUpdateOfferResponse,
}) => {
  const [selectedOfferId, setSelectedOfferId] = useState(null);
  const [open, setOpen] = useState(false); // State for Modal visibility
  const [isCounterMode, setIsCounterMode] = useState(false);
  const [counterPrice, setCounterPrice] = useState('');
  const [counterError, setCounterError] = useState('');

  const navigate = useNavigate();

  const handleOpenModal = (id) => {
    setSelectedOfferId(id);
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
    setIsCounterMode(false);
    setCounterPrice('');
    setCounterError('');
    setUpdateOfferResponse(null);
    triggerRefresh();
  };

  const handleAcceptOffer = async (id) => {
    if (id) {
      await onUpdate(id, "OfferAccepted");
    }
  };

  const handleRejectOffer = async (id) => {
    if (selectedOfferId) {
      await onUpdate(selectedOfferId, "OfferRejected");
      handleCloseModal();
    }
  };

  const handleCounterOffer = () => {
    setIsCounterMode(true);
  };

  const handleSubmitCounter = async () => {
    if (!selectedOfferId) return;
    const priceNumber = Number(counterPrice);
    const minAllowed = offer?.offer?.counterOfferPrice != null ? Number(offer.offer.counterOfferPrice) : 0;

    if (Number.isNaN(priceNumber)) {
      setCounterError('Please enter a valid amount');
      return;
    }
    if (priceNumber < 0) {
      setCounterError('Counter offer cannot be negative');
      return;
    }
    if (priceNumber < minAllowed) {
      setCounterError(`Counter offer must be >= $${minAllowed}`);
      return;
    }
    setCounterError('');
    await onCounter(selectedOfferId, priceNumber);
    await onUpdate(selectedOfferId, "Countered");
    handleCloseModal();
  };

  const handleNavigate = () => {
    navigate(`/local-vehicle-detail/${offer?.carData?.id || "-"}`);
  };

  const getStatusMeta = (rawStatus) => {
    const s = (rawStatus || '').toString().toLowerCase();
    if (s === 'offeraccepted' || s === 'accepted') {
      return { label: 'ACCEPTED', text: 'text-green-700', bg: 'bg-green-100' };
    }
    if (s === 'offerrejected' || s === 'rejected') {
      return { label: 'REJECTED', text: 'text-red-700', bg: 'bg-red-100' };
    }
    if (s === 'pending') {
      return { label: 'PENDING', text: 'text-amber-700', bg: 'bg-amber-100' };
    }
    if (s === 'expired') {
      return { label: 'EXPIRED', text: 'text-gray-700', bg: 'bg-gray-200' };
    }
    if (s === 'countered' || s === 'counter') {
      return { label: 'COUNTERED', text: 'text-orange-700', bg: 'bg-orange-100' };
    }
    return { label: rawStatus || '-', text: 'text-gray-700', bg: 'bg-gray-100' };
  };

  return (
    <>
      <tr className="border-t">
        {/* Car Image */}
        <td className="text-nowrap px-4 lg:px-[1vw] py-2 lg:py-[0.5vw] lg:text-[1vw]">
          <div className="w-[60px] lg:w-[3.125vw] h-[60px] lg:h-[3.125vw] rounded-md lg:rounded-[0.375vw] overflow-hidden bg-gray-100">
            <img
              className="w-full h-full object-cover"
              src={offer.carData?.carImages[0] || ""}
              alt="Car"
            />
          </div>
        </td>
        {/* Car Title */}
        <td
          className="text-nowrap px-4 lg:px-[1vw] py-2 lg:py-[0.5vw] lg:text-[1vw] hover:text-blue-800 hover:underline cursor-pointer"
          onClick={handleNavigate}
        >
          {`${offer.carData?.title
          }`}
        </td>
        {/* VIN */}
        <td className="text-nowrap px-4 lg:px-[1vw] py-2 lg:py-[0.5vw] lg:text-[1vw]">{offer.carData?.vin || "-"}</td>

        {/* Offer Price */}
        <td className="text-nowrap px-4 lg:px-[1vw] py-2 lg:py-[0.5vw] lg:text-[1vw] font-bold">
          <span className={""}>${offer.offer?.offerPrice || "N/A"}</span>
        </td>

        {/* Status */}
        {(() => {
          const meta = getStatusMeta(offer.offer?.offerStatus);
          return (
            <td className={"text-nowrap px-4 lg:px-[1vw] py-2 lg:py-[0.5vw] lg:text-[1vw]"}>
              <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold ${meta.text} ${meta.bg}`}>
                {meta.label}
              </span>
            </td>
          );
        })()}

        {/* Counter Offer Price */}
        <td className="text-nowrap px-4 lg:px-[1vw] py-2 lg:py-[0.5vw] lg:text-[1vw] font-bold">
          <span>{offer.offer?.counterOfferPrice ? `$${offer.offer.counterOfferPrice}` : "N/A"}</span>
        </td>

        {/* Posted Time Ago */}
        <td className="text-nowrap px-4 lg:px-[1vw] py-2 lg:py-[0.5vw] lg:text-[1vw]">
          <TimeAgo date={offer.carData?.createdAt} />
        </td>

        {/* Offer Created (createdAt) */}
        <td className="text-nowrap px-4 lg:px-[1vw] py-2 lg:py-[0.5vw] lg:text-[1vw]">
          {offer.offer?.createdAt ? <TimeAgo date={offer.offer.createdAt} /> : "-"}
        </td>

        {/* Accept offer button */}
        <td className={`text-nowrap font-semibold`}>
          {(offer.offer?.offerStatus === "Pending" && (
            <button
              className="bg-green-500 hover:bg-green-600 text-xs lg:text-[1vw] text-white   p-1 lg:px-[0.5vw] lg:py-[2vh] rounded"
              onClick={() => handleOpenModal(offer?.offer?.id)}
            >
              Update Offer
            </button>
          ))}
        </td>
      </tr>

      {/* Material UI Modal for confirmation */}
      <Modal
        open={open}
        onClose={handleCloseModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box sx={style}>
          {loading ? (
            <div className="flex justify-center items-center">
              <ClipLoader size={30} color={"#D0021B"} loading={loading} />
            </div>
          ) : error ? (
            <p className="text-red-500 text-center">{error}</p>
          ) : updateOfferResponse?.data?.offerData?.offerStatus ===
            "OfferAccepted" ? (
            <>
              <div className="flex flex-col items-center">
                <img
                  src={luxLogo}
                  alt="Bidcaribbean Logo"
                  className="w-20 h-auto mb-4"
                />
                <p className="text-green-500 text-center font-semibold">
                  {updateOfferResponse?.message}
                </p>
                <p className="text-gray-700 text-center mt-2">
                  Thank you for accepting the offer. Please wait for Bidcaribbean
                  response. Our team will review your offer and get back to you
                  shortly.
                </p>
                <button
                  className="btn dark:bg-white dark:border-gray-600 dark:text-gray-600 hover:bg-gray-600 hover:text-white text-gray-600 w-[100px] mt-4"
                  onClick={handleCloseModal}
                >
                  Close
                </button>
              </div>
            </>
          ) : (
            <>
              {isCounterMode ? (
                <>
                  <h3 id="modal-title" className="font-bold text-lg">Counter Offer</h3>
                  <div className="py-4">
                    <label className="block text-sm mb-2">Enter counter-offer price</label>
                    <input
                      type="number"
                      min={offer?.offer?.counterOfferPrice != null ? offer.offer.counterOfferPrice : 0}
                      value={counterPrice}
                      onChange={(e) => {
                        const value = e.target.value;
                        setCounterPrice(value);
                        if (value === '') {
                          setCounterError('');
                          return;
                        }
                        const n = Number(value);
                        const minAllowed = offer?.offer?.counterOfferPrice != null ? Number(offer.offer.counterOfferPrice) : 0;
                        if (Number.isNaN(n)) {
                          setCounterError('Please enter a valid amount');
                        } else if (n < 0) {
                          setCounterError('Counter offer cannot be negative');
                        } else if (n < minAllowed) {
                          setCounterError(`Counter offer must be greater than $${minAllowed}`);
                        } else {
                          setCounterError('');
                        }
                      }}
                      className="w-full px-3 py-2 border border-gray-300 rounded"
                      placeholder={`e.g. $${offer?.offer?.counterOfferPrice != null ? offer.offer.counterOfferPrice+Number(500) : 15000}`}
                    />
                    {counterError && (
                      <p className="text-red-600 text-sm mt-2">{counterError}</p>
                    )}
                  </div>
                  <div className="flex flex-wrap gap-2 justify-center">
                    <button
                      className="btn text-green-600 w-full sm:w-[120px] dark:bg-white dark:border-green-600 dark:text-green-600 hover:bg-green-600 hover:text-white"
                      disabled={counterPrice === '' || !!counterError}
                      onClick={handleSubmitCounter}
                    >
                      Submit
                    </button>
                    <button
                      className="btn text-gray-600 w-full sm:w-[120px] dark:bg-white dark:border-gray-600 dark:text-gray-600 hover:bg-gray-600 hover:text-white"
                      onClick={() => setIsCounterMode(false)}
                    >
                      Back
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <h3 id="modal-title" className="font-bold text-lg">
                    Update Offer
                  </h3>
                  <p id="modal-description" className="py-4">
                    Accept, Reject, or send a Counter Offer.
                  </p>
                  <div className="flex flex-wrap gap-2 justify-center">
                    <button
                      className="btn text-green-600 w-full sm:w-[120px] dark:bg-white dark:border-green-600 dark:text-green-600 hover:bg-green-600 hover:text-white"
                      onClick={() => handleAcceptOffer(offer?.offer?.id)}
                    >
                      Accept
                    </button>
                    <button
                      className="btn text-orange-600 w-full sm:w-[120px] dark:bg-white dark:border-orange-600 dark:text-orange-600 hover:bg-orange-600 hover:text-white"
                      onClick={handleCounterOffer}
                    >
                      Counter
                    </button>
                    <button
                      className="btn text-red-600 w-full sm:w-[120px] dark:bg-white dark:border-red-600 dark:text-red-600 hover:bg-red-600 hover:text-white"
                      onClick={handleRejectOffer}
                    >
                      Reject
                    </button>
                    <button
                      className="btn text-gray-600 w-full sm:w-[120px] dark:bg-white dark:border-gray-600 dark:text-gray-600 hover:bg-gray-600 hover:text-white"
                      onClick={handleCloseModal}
                    >
                      Cancel
                    </button>
                  </div>
                </>
              )}
            </>
          )}
        </Box>
      </Modal>
    </>
  );
};

export default OfferCards;
